import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const FormItem = Form.Item

class ReservationCancelForm extends React.Component {
  static propTypes = {
    form: PropTypes.object
  }

  componentDidMount () {
    const { form } = this.props
    if (!form || !form.current) return
    form.current.setFieldsValue({ reason: '' })
  }

  render () {
    const { form } = this.props
    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="取消原因"
          name="reason"
          rules={[{ required: true, message: '请填写取消原因' }]}
        >
          <Input.TextArea
            rows={3}
            size="large"
            placeholder="请填写取消原因"
            allowClear
            maxLength={512}
            showCount
          />
        </FormItem>
      </Form>
    )
  }
}

export default ReservationCancelForm
